<template>
  <b-card>
    <div>
      <b-dropdown
        class="dropdown float-right mr-50"
        :text="filtrosVencendo.data"
        size="sm"
        variant="outline-warning"
      >
        <b-dropdown-item
          v-for="(tipo, index) in filtroTipoData"
          :key="index"
          @click="alterouFiltroVencendo(tipo)"
        >
          {{ tipo.nome }}
        </b-dropdown-item>
      </b-dropdown>
      <h4>Teste Expirando</h4>
      
      <h2 class="font-weight-bolder mb-1">
       {{ items.length }}
      </h2>
      
      <div>
        <b-row>
          <b-button
            class="mx-1"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-warning"
            size="sm"
            @click="clicouVisualizar = !clicouVisualizar"
          >
            Visualizar
          </b-button>
          
       
        </b-row>
      </div>
    </div>

    <div v-if="clicouVisualizar" class="listaServicos">
      <hr class="mb-0" />
      <b-list-group flush>
        <b-list-group-item
          class="pb-0"
          v-for="(item, index) in items"
          :key="index"
        >
          <b-row class="font-small-3" :id="`popover-vencendo-info-${index}`">
            <b-col md="2" class="pr-0">
              <span>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  class="btn-icon"
                  :pressed="true"
                  :variant="
                    item.data_expiracao === $getDate.hoje()
                      ? 'flat-danger'
                      : 'flat-warning'
                  "
                >
                  <span>{{ item.id_company }}</span>
                </b-button>
              </span>
            </b-col>
            <b-col md="10">
              <ul class="list-unstyled">
                <li><strong>Nome</strong>: {{ item.nome }}</li>
                <li><strong>Tel Comercial:</strong> {{ item.tel_comercial }}</li>
                <li><strong>Celular: </strong>{{ item.celular_um }}</li>
                <li><strong>email:</strong> {{ item.email }}</li>
                <li><strong>Data Expiração</strong> {{ item.data_expiracao | converteData }}</li>
              </ul>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>
<script>
import {
  BCard,
  BBadge,
  VBModal,
  BModal,
  BButton,
  BRow,
  BCol,
  BAvatar,
  BListGroup,
  BListGroupItem,
  BCardFooter,
  BDropdown,
  BDropdownItem,
  BPopover,
  VBPopover,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";



export default {
  components: {
    BCard,
    BBadge,
    BModal,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BListGroup,
    BListGroupItem,
    BCardFooter,
    BDropdown,
    BDropdownItem,
    BPopover,
    VBPopover,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
    "b-popover": VBPopover,
  },
  data() {
    return {
      clicouVisualizar: false,
      clicouOrdemOs: false,
      clicouOrdemData: false,
      filtroTipoData: [
        { value: 0, nome: 'Hoje' },
        { value: 5, nome: '5 dias' },
        { value: 10, nome: '10 dias' },
        { value: 15, nome: '15 dias' },
      ],
      filtrosVencendo: { valor: 0, data: 'Hoje' },
      items: []
    };
  },
  
  methods:{
    alterouFiltroVencendo(val) {
      console.log(val)
      this.filtrosVencendo = { valor: val.value, data: val.nome }
      this.buscarVencendo()
    },
    buscarVencendo() {
      this.$http.get(`adm/dashboard/teste-vencendo/${this.filtrosVencendo.valor}`).then((res) => {
        this.items = res.data
      })
    }
  },
  
  mounted() {
   this.buscarVencendo()
  },
  
  filters: {
    converteData(data) {
      if (!data) return;
      
      const d = data.split("-");
      return `${d[2]}/${d[1]}/${d[0]}`;
    },
  },
  
}
</script>
<style scoped>
.listaServicos {
  max-height: 400px;
  overflow-y: scroll;
}
</style>

